import * as React from "react";
import type { SVGProps } from "react";

const SvgEligibilityList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={22}
    height={22}
    viewBox="-2 0 22 22"
    {...props}
  >
    <defs>
      <path id="eligibility-list_svg__a" d="M0 0h18v22H0z" />
      <path id="eligibility-list_svg__c" d="M.49.491H8v5.508H.49z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#182744"
        d="M13.25 16.5h-8.5a.75.75 0 0 0-.75.75c0 .412.337.75.75.75h8.5c.412 0 .75-.338.75-.75a.75.75 0 0 0-.75-.75m0-4h-8.5a.75.75 0 0 0-.75.75c0 .412.337.75.75.75h8.5c.412 0 .75-.338.75-.75a.75.75 0 0 0-.75-.75m0-4h-8.5a.75.75 0 0 0-.75.75c0 .412.337.75.75.75h8.5c.412 0 .75-.338.75-.75a.75.75 0 0 0-.75-.75"
      />
      <mask id="eligibility-list_svg__b" fill="#fff">
        <use xlinkHref="#eligibility-list_svg__a" />
      </mask>
      <path
        fill="#182744"
        d="M17.25 5.1a.75.75 0 0 0-.75.75v11.3c0 1.847-1.309 3.35-2.917 3.35H4.416c-1.607 0-2.916-1.503-2.916-3.35V4.85c0-1.847 1.309-3.35 2.916-3.35h8.167a.75.75 0 0 0 0-1.5H4.416C1.981 0 0 2.176 0 4.85v12.3C0 19.825 1.981 22 4.416 22h9.167C16.019 22 18 19.825 18 17.15V5.85a.75.75 0 0 0-.75-.75"
        mask="url(#eligibility-list_svg__b)"
      />
      <path
        fill="#182744"
        d="M4.75 6h4.5c.412 0 .75-.338.75-.75a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75c0 .412.337.75.75.75"
      />
      <g transform="translate(10)">
        <mask id="eligibility-list_svg__d" fill="#fff">
          <use xlinkHref="#eligibility-list_svg__c" />
        </mask>
        <path
          fill="#182744"
          d="M1.77 2.71A.75.75 0 0 0 .71 3.771l1.98 1.98c.009.01.011.021.02.03a.74.74 0 0 0 .535.218.75.75 0 0 0 .536-.218c.01-.009.011-.02.02-.03l3.98-3.98a.749.749 0 1 0-1.06-1.06L3.245 4.184z"
          mask="url(#eligibility-list_svg__d)"
        />
      </g>
    </g>
  </svg>
);
export default SvgEligibilityList;
